import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { mapActions, mapGetters, mapState } from 'vuex'
import { Spinner } from '@kwixeo/interface-vue'
import { KFormSelect, KFormSpinner, KFormNumber } from '@kwixeo/form-vue'
import { BTabs, BTab, BRow, BCol, BFormGroup, BButton, BInputGroup } from 'bootstrap-vue'

@Component({
  computed: {
    ...mapGetters('user', ['currency']),
    ...mapState('customers', ['customerTypes'])
  },
  methods: {
    ...mapActions('customers', ['loadCustomerTypes'])
  },
  components: {
    Spinner,
    KFormSelect, KFormSpinner, KFormNumber,
    BTabs, BTab, BRow, BCol, BFormGroup, BButton, BInputGroup
  }
})
export default class CustomPrices extends Vue {
  loadCustomerTypes!: (force?: boolean) => void
  customerTypes!: KwixeoCustomers.CustomerTypes

  @Prop({ default: null }) value!: KwixeoCatalog.Product|KwixeoCatalog.Service|null

  localElement: KwixeoCatalog.CustomPricesForm = {
    custom_price_mode: 'quantity',
    custom_price_customer_type_prices: [],
    custom_price_customer_prices: [],
    custom_price_country_prices: [],
    custom_quantity_prices: [],
    custom_price_quantity_mode: 5
  }

  private customPriceMode = [
    { id: 'quantity', label: this.$t('catalog.customPrices.decreasingPrices') },
    { id: 'type', label: this.$t('catalog.customPrices.byCustomerType') },
    { id: 'customer', label: this.$t('catalog.customPrices.byCustomer') },
    { id: 'country', label: this.$t('catalog.customPrices.byCountry') }
  ]

  private customPriceQuantityModes = [
    { id: 1, label: this.$t('catalog.customPrices.qtyOnDocument') },
    { id: 2, label: this.$t('catalog.customPrices.qtyCurrentYear') },
    { id: 3, label: this.$t('catalog.customPrices.qtyPreviousYear') },
    { id: 4, label: this.$t('catalog.customPrices.qtyLastMonths') },
    { id: 5, label: this.$t('catalog.customPrices.qtyTotal') }
  ]

  private customersCache: KwixeoForm.SelectAjaxCache = {}

  private loading = true

  async mounted (): Promise<void> {
    await this.loadCustomerTypes()
    this.watchValue()
    this.loading = false
  }

  @Watch('value')
  private watchValue (): void {
    if (this.value) {
      this.setLocalElement(this.value)
    } else {
      this.localElement.custom_price_customer_type_prices = this.customerTypes
    }
  }

  get customerApiUrl (): string {
    return '/customer?sort=name&filter[is_prospect_or_customer]=1'
  }

  get countryApiUrl (): string {
    return '/country?sort=name'
  }

  get getCustomerTypes (): KwixeoCatalog.CustomPriceTypeForm[] {
    const customPrice = this.value && this.value.custom_type_prices ? this.value.custom_type_prices.filter(price => price.type === 'customerType') : []
    return this.customerTypes.map(type => {
      const custom = customPrice.find(price => price.type === 'customerType' && price.id === type.id)
      return Object.assign({
        price: custom?.price
      }, type)
    })
  }

  protected setLocalElement (element: KwixeoCatalog.Product|KwixeoCatalog.Service): void {
    const customPrice = element.custom_type_prices ? element.custom_type_prices.filter(price => price.type === 'customerType') : []
    const types: KwixeoCatalog.CustomPriceTypeForm[] = this.customerTypes.map(type => {
      const custom = customPrice.find(price => price.type === 'customerType' && price.id === type.id)
      return Object.assign({
        price: custom?.price
      }, type)
    })

    this.localElement = {
      custom_price_mode: element.custom_price_mode,
      custom_price_customer_type_prices: JSON.parse(JSON.stringify(types)),
      custom_price_customer_prices: element.custom_type_prices ? element.custom_type_prices.filter(price => price.type === 'customer') : [],
      custom_price_country_prices: element.custom_type_prices ? element.custom_type_prices.filter(price => price.type === 'country') : [],
      custom_quantity_prices: element.custom_quantity_prices ?? [],
      custom_price_quantity_mode: element.custom_price_quantity_mode ?? 5,
      custom_price_quantity_month_length: element.custom_price_quantity_month_length
    }
  }

  protected addNewCustomerPrice (): void {
    this.localElement.custom_price_customer_prices.push({})
  }

  protected deleteCustomerPrice (index: number): void {
    this.localElement.custom_price_customer_prices.splice(index, 1)
  }

  protected addNewCountryPrice (): void {
    this.localElement.custom_price_country_prices.push({})
  }

  protected deleteCountryPrice (index: number): void {
    this.localElement.custom_price_country_prices.splice(index, 1)
  }

  protected addQuantityPrice (): void {
    this.localElement.custom_quantity_prices.push({})
  }

  protected deleteQuantityPrice (index: number): void {
    this.localElement.custom_quantity_prices.splice(index, 1)
  }
}
